import { useSelector } from 'react-redux';
import QuickCard from 'src/components/cards/QuickCard';
import Grid from 'src/components/layouts/Grid';
import Page from 'src/components/layouts/Page';
import EmptyPage from 'src/components/molecules/EmptyPage';
// import css from "./Home.module.scss";

export default function Home() {
  const { counts } = useSelector((state) => state.info);
  const { permissions } = useSelector((state) => state.auth);

  return (
    <Page>
      {['orders', 'pendingOffers', 'pendingItems', 'offers', 'items'].some((field) =>
        permissions.read.includes(field),
      ) || permissions.update.includes('store_info') ? (
        <Grid stlye={{ gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))' }}>
          {permissions.read.includes('orders') && (
            <QuickCard
              title="Orders"
              iconName="receipt"
              badgeCount={counts.orders}
              buttonProps={{ href: '/orders', label: 'View All' }}
            />
          )}
          {permissions.read.includes('pendingOffers') && (
            <QuickCard
              title="Pending Offers"
              iconName="clock"
              badgeCount={counts.pendingOffers}
              buttonProps={{ href: '/pending-offers', label: 'View All' }}
            />
          )}
          {permissions.read.includes('pendingItems') && (
            <QuickCard
              title="Pending Items"
              iconName="clock"
              badgeCount={counts.pendingItems}
              buttonProps={{ href: '/pending-items', label: 'View All' }}
            />
          )}
          {permissions.read.includes('offers') && (
            <QuickCard
              title="Offers"
              iconName="tags"
              badgeCount={counts.offers}
              buttonProps={{ href: '/offers', label: 'View All' }}
              button2Props={{
                href: '/offers/new',
                label: 'Create',
                iconLeft: 'fad fa-plus',
                // action: !permissions.create.includes('offers'),
                // disabled: !permissions.create.includes('offers'),
                // color: !permissions.create.includes('offers') ? 'gray' : 'blue',
                // variant: !permissions.create.includes('offers')
                // 	? 'secondary'
                // 	: 'primary',
              }}
            />
          )}
          {permissions.read.includes('items') && (
            <QuickCard
              title="Items"
              iconName="tag"
              badgeCount={counts.items}
              buttonProps={{ href: '/items', label: 'View All' }}
              button2Props={{
                href: '/items/new',
                label: 'Create',
                iconLeft: 'fad fa-plus',
                // action: !permissions.create.includes('items'),
                // disabled: !permissions.create.includes('items'),
                // color: !permissions.create.includes('items') ? 'gray' : 'blue',
                // variant: !permissions.create.includes('items')
                // 	? 'secondary'
                // 	: 'primary',
              }}
            />
          )}
          {permissions.update.includes('store_info') && (
            <QuickCard
              title="Live Message"
              iconName="comment"
              buttonProps={{
                href: '/store-details#live',
                label: 'Edit',
                iconLeft: 'fad fa-edit',
              }}
            />
          )}
        </Grid>
      ) : (
        <EmptyPage
          title="You don’t have permission to view anything on this page"
          text="Ask your employer for access"
          iconName="fad fa-lock"
        />
      )}
    </Page>
  );
}
